export default __webpack_public_path__ + "static/spiritual-india-people-4-032a4282dfcece94481f0bd8076623da.jpg";